import React from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { logger } from '@zep/core-logger';
import { TranslationFillIcon } from '@/icons';
import { SUPPORTED_TRANSLATION_LANGUAGES, type SupportedTranslationLanguage } from '@/module/play/hook/translation';
import { useLanguageName } from '@/shared/i18n/displayName';
import { useUpsellingGuard, useUserPlanManager } from '@/shared/plan';
import { MultiSelect } from '@/ui_v3/components/select/MultiSelect';
import { BuildProFeatureCoachmarkAnchor } from '../components/BuildProFeatureCoachmark';
import { FeatureUpsellModal } from '../components/FeatureUpsellModal';
import { useBuildFormContext } from '../form/schema';
import { ToggleOptionContainer } from './ToggleOptionContainer';
export const ToggleAiTranslationField = () => {
  const {
    setValue,
    watch
  } = useBuildFormContext();
  const {
    t
  } = useTranslation(['build']);
  const {
    userPlanManager
  } = useUserPlanManager();
  const upsellingGuard = useUpsellingGuard();
  const isAiTranslationEnabled = watch('isAiTranslationEnabled');
  const aiTranslationLanguages = watch('aiTranslationLanguages') as SupportedTranslationLanguage[];
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_QUIZSET_TRANSLATION');
  return <div className="flex flex-col gap-sm" data-sentry-component="ToggleAiTranslationField" data-sentry-source-file="ToggleAiTranslationField.tsx">
      <ToggleOptionContainer optionIcon={<TranslationFillIcon size="sm" fill={ICON_COLOR.neutral} />} optionTitle={t('build.option.aiTranslationTitle')} optionDescription={t('build:aiTranslation.description')} isOn={isAiTranslationEnabled} onToggle={() => {
      logger.track('빌드_AI_번역_옵션', {
        value: !isAiTranslationEnabled
      });
      upsellingGuard(() => {
        setValue('isAiTranslationEnabled', !isAiTranslationEnabled, {
          shouldDirty: true
        });
      }, {
        feature: 'AI_QUIZSET_TRANSLATION',
        from: 'aiTranslation',
        moreConditionForGuard: isAiTranslationEnabled === false,
        onGuard: () => {
          overlay.open(({
            unmount
          }) => <FeatureUpsellModal feature="AI_QUIZSET_TRANSLATION" onClose={unmount} />);
        }
      });
    }} planType={featurePlanType} isBadgeVisible={true} renderToggle={toggle => <BuildProFeatureCoachmarkAnchor feature="AI_QUIZSET_TRANSLATION">
            {toggle}
          </BuildProFeatureCoachmarkAnchor>} data-sentry-element="ToggleOptionContainer" data-sentry-source-file="ToggleAiTranslationField.tsx" />

      {isAiTranslationEnabled && <AiTranslationSelect selectedLanguages={aiTranslationLanguages} onChange={languages => {
      setValue('aiTranslationLanguages', languages, {
        shouldDirty: true
      });
    }} />}
    </div>;
};
const AiTranslationSelect = ({
  selectedLanguages,
  onChange
}: {
  selectedLanguages: SupportedTranslationLanguage[];
  onChange: (languages: SupportedTranslationLanguage[]) => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const languageName = useLanguageName();
  const options = SUPPORTED_TRANSLATION_LANGUAGES.map(language => ({
    label: languageName(language),
    value: language
  }));
  const MAX_SELECT_COUNT = 3;
  return <div className="w-full" data-sentry-component="AiTranslationSelect" data-sentry-source-file="ToggleAiTranslationField.tsx">
      <MultiSelect options={options} values={selectedLanguages} onValuesChange={onChange} placeholder={t('build.option.aiTranslationSelectPlaceholder')} maxCount={MAX_SELECT_COUNT} helperText={t('build.option.aiTranslationSelectHelperText', {
      selected: selectedLanguages.length,
      limit: MAX_SELECT_COUNT
    })} hasDrawerHandle data-sentry-element="MultiSelect" data-sentry-source-file="ToggleAiTranslationField.tsx" />
    </div>;
};